// imports arriba del archivo
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtMoney } from "./functions";

// formateador rápido de dinero


// Genera y descarga el voucher de multa
function generarVoucherMultaPDF({ multa, prestamo, emitidoPor }) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const now = new Date();
  const fechaStr = now.toLocaleDateString("es-NI", { day: "2-digit", month: "2-digit", year: "numeric" });
  const horaStr  = now.toLocaleTimeString("es-NI", { hour: "2-digit", minute: "2-digit" });

  // Header
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Universidad Americana (UAM)", 40, 50);
  doc.setFontSize(14);
  doc.text("Biblioteca - Voucher de Multa", 40, 75);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text(`Fecha: ${fechaStr}  ${horaStr}`, 40, 95);
  doc.text(`Emitido por: ${emitidoPor ?? "-"}`, 320, 95);

  // Datos del estudiante y del préstamo
  const alumno = prestamo?.usuario;
  const libro  = prestamo?.libro;

  autoTable(doc, {
    startY: 120,
    styles: { fontSize: 10, cellPadding: 6 },
    headStyles: { fillColor: [33, 128, 124] },
    head: [["Campo", "Valor"]],
    body: [
      ["Código de Retiro", prestamo?.codigoRetiro ?? "-"],
      ["ID Préstamo", String(prestamo?.idPrestamo ?? "-")],
      ["Usuario", alumno?.nombreCompleto ?? "-"],
      ["CIF", alumno?.cif ?? "-"],
      ["Libro", libro?.titulo ?? "-"],
      ["ISBN", libro?.isbn ?? "-"],
      ["Estado multa", multa?.estado ? "Activa" : "Pagada/Desactivada"],
    ],
  });

  // Importe
  const y = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 20 : 220;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text(`TOTAL A PAGAR: ${fmtMoney(multa?.montoMulta)}`, 40, y);

  // Nota
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    "Preséntese en Caja con este voucher. Conserve el comprobante de pago para " +
    "entregarlo en Biblioteca y regularizar su estado.",
    40,
    y + 22,
    { maxWidth: 515 }
  );

  // Footer
  doc.setFontSize(11);
  doc.setTextColor(150);
  doc.text("Generado automáticamente por UAMlibrary", 40, 790);

  const file = `voucher_multa_${prestamo?.codigoRetiro ?? prestamo?.idPrestamo ?? "prestamo"}.pdf`;
  doc.save(file);
}

export default generarVoucherMultaPDF;